import css from 'styled-jsx/css';

const styles = css.global`.blog-recent {
  display: flex;
  min-width: 200px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 48px;
}

.blog-recent h2 {
  font-weight: normal;
  margin: 48px 0 42px;
  font-size: 32px;
  color: #222222;
  font-family: 'Open Sans';
}

.carousel-wrapper {
  position: relative;
  width: 100%;
  margin-bottom: 48px;
}

.recent-post {
  margin-left: 16px;
}

.recent-post h3 {
  position: absolute;
  z-index: 10;
  color: #fff;
  margin: 20px 0;
  padding: 0 20px;
  width: 263px;
  box-sizing: border-box;
  font-size: 20px;
  line-height: 28px;
  font-family: 'Open Sans';
}

.recent-post img {
  overflow: hidden;
  filter: brightness(0.5);
}

.recent-post img {
  transition: 0.3s ease;
  object-fit: cover;
  position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: block;
    height: 0;
    max-height: 100%;
    max-width: 100%;
    min-height: 100%;
    min-width: 100%;
    width: 0;
    margin: auto;
}

.recent-post > div{
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  width: 263px;
  height: 239px;
}

.recent-post:hover img {
  transform: scale(1.05);
  overflow: hidden;
}

.blog-recent amp-carousel .amp-carousel-button {
  background-color: transparent;
  width: 24px;
  height: 40px;
  opacity: 1;
  background-size: 24px 40px;
  outline: none;
  border: none;
  cursor: pointer;
}

.blog-recent amp-carousel .amp-carousel-button-next {
  background-image: url('../static/amp/shared/assets/ic_arrow2_r.svg');
}

.blog-recent amp-carousel .amp-carousel-button-prev {
  background-image: url('../static/amp/shared/assets/ic_arrow2_l.svg');
}

.embla__prev {
  background: none;
  border: none;
  background-color: transparent;
  width: 24px;
  height: 40px;
  opacity: 1;
  background-size: 24px 40px;
  outline: none;
  border: none;
  cursor: pointer;
  background-image: url('../static/amp/shared/assets/ic_arrow2_l.svg');
  margin: 16px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
}

.embla__next {
  background: none;
  border: none;
  background-color: transparent;
  width: 24px;
  height: 40px;
  opacity: 1;
  background-size: 24px 40px;
  outline: none;
  border: none;
  cursor: pointer;
  background-image: url('../static/amp/shared/assets/ic_arrow2_r.svg');
  margin: 16px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
}

@media (min-width: 992px) {
  .recent-post {
    margin-left: 40px;
  }
}

.embla {
  overflow: hidden;
  max-width: 100%;
  position: relative;
}
.embla__container {
  display: flex;
}
.embla__slide {
  position: relative;
  flex: 0 0 263.71px;
  margin: 0 8px;
}
`;

export default styles;